const TortillasBeauty = () => {
  return (
    <img
      alt="Tortilla's Beauty'"
      src="/static/tortilla/beauty.png"
      style={{ maxHeight: 'fit-content', margin: '0 auto' }}
    />
  );
};

export default TortillasBeauty;
